export default "__VITE_ASSET__DeS2A0M5__"